import React from 'react'
import moment from 'moment'
import { BaseListItem } from '@src/components/list/common/BaseListItem'
import { Text } from '@components/base'
import { Measurement } from '@src/types'
import { HOUR_MINUTE_AM_PM } from '@src/config/momentFormat'

export interface ScanListItemProps {
  item: Measurement
}

export const ScanListItem = (props: ScanListItemProps) => {
  const { item } = props
  const { title, value, occurredAt, displayValue } = item

  const renderImageContent = () => {
    const valueToDisplay = displayValue || value
    return <Text type="title-3">{valueToDisplay as number | string}</Text>
  }

  return (
    <BaseListItem
      title={title}
      info={moment(occurredAt).format(HOUR_MINUTE_AM_PM)}
      renderImageContent={renderImageContent}
    />
  )
}
